import { WebCoreIoCKeys, IoCContainer, ITranslation, IWebsiteConstants, INotificationService, IUtils, IEventHandler, IWebCoreSettings, IRandomSentenceGenerator, ISidebarManagerComponent } from 'web-core-src';
import { IWebCoreIoCContainer } from './web-core-ioc-container.interface';
import { IWebCoreSensitiveSettings } from '../web-core-sensitive-settings/web-core-sensitive-settings.interface';

export class WebCoreIoCContainer implements IWebCoreIoCContainer {
    public lateBindIoC(): void {
        this.settings = IoCContainer.get(WebCoreIoCKeys.IWebCoreSettings);
        this.sensitiveSettings = IoCContainer.get(WebCoreIoCKeys.IWebCoreSensitiveSettings);

        this.translation = IoCContainer.get(WebCoreIoCKeys.ITranslation);
        this.utils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        this.websiteConstants = IoCContainer.get(WebCoreIoCKeys.IWebsiteConstants);
        this.notificationService = IoCContainer.get(WebCoreIoCKeys.INotificationService);
        this.eventHandler = IoCContainer.get(WebCoreIoCKeys.IEventHandler);
        this.randomSentenceGenerator = IoCContainer.get(WebCoreIoCKeys.IRandomSentenceGenerator);
        this.sidebarManager = IoCContainer.get(WebCoreIoCKeys.ISidebarManagerComponent);
    }

    public settings: IWebCoreSettings;
    public sensitiveSettings: IWebCoreSensitiveSettings;

    public translation: ITranslation;
    public utils: IUtils;

    public websiteConstants: IWebsiteConstants;
    public notificationService: INotificationService;
    public eventHandler: IEventHandler;
    public randomSentenceGenerator: IRandomSentenceGenerator;
    public sidebarManager: ISidebarManagerComponent;
}
